<template>
  <v-dialog v-model="dialogEditPosition" persistent max-width="550px">
    <v-card class="pa-5">
        <!-- <v-card-title>
        </v-card-title> -->
        <v-card-text>
          <v-container>
            <v-row style="margin-top: -2%;">
              <v-col cols="12">
                <span class="mb-0"></span>
                <h1 class="ra-head-text-bold mb-0" style="color: #333333;">แก้ไขตำแหน่งงาน</h1>
              </v-col>
            </v-row>
            <v-row class="" justify=center>
              <v-col cols="12">
                <v-divider></v-divider>
              </v-col>
            </v-row>
            <v-row style="margin-top: -2%;">
              <v-col cols="12">
                <span class="mb-0">ชื่อตำแหน่งงาน</span>
                <v-combobox
                  v-model="position"
                  :items="selectDataPosition"
                  placeholder="ชื่อตำแหน่ง"
                  class="mt-0"
                  item-text="positionName"
                  outlined
                  dense
                  color="#333"
                  clearable
                  @keyup="getSelectCompany($event.target.value, 'ตำแหน่งงาน')"
                  @click:clear="position='', getSelectCompany()"
                >
                  <template v-slot:selection="">
                  </template>
                  <template slot="selection" slot-scope="{ item }">
                    <div v-if="item.positionName">
                      <span >{{item.positionName}}</span>
                    </div>
                    <div v-else>
                      <span>{{item}}</span>
                    </div>
                  </template>
                </v-combobox>
                <!-- <v-autocomplete
                  v-model="position"
                  :items="selectDataPosition"
                  item-text="positionName"
                  outlined
                  placeholder="ชื่อตำแหน่ง"
                  no-data-text="ไม่พบข้อมูล"
                  class="mt-0"
                  dense
                  color="#333"
                  clearable
                  @keyup="getSelectCompany($event.target.value, 'ตำแหน่งงาน')"
                >
                </v-autocomplete> -->
              </v-col>
            </v-row>
            <v-row style="margin-top: -2%;">
              <v-col cols="12">
                <span class="mb-0">ระดับตำแหน่งงาน</span>
                <v-autocomplete
                  v-model="positionLevel"
                  :items="selectDataLevel"
                  item-text="positionLvName"
                  item-value="_id"
                  outlined
                  placeholder="ชื่อระดับตำแหน่ง"
                  no-data-text="ไม่พบข้อมูล"
                  class="mt-0"
                  dense
                  color="#333"
                  clearable
                  @keyup="getSelectCompany($event.target.value, 'ระดับตำแหน่ง')"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <span class="mb-0">บริษัท</span>
                <v-autocomplete
                  v-model="companyName"
                  :items="selectData"
                  item-text="companyFullNameTh"
                  item-value="_id"
                  dense
                  placeholder="ชื่อบริษัท"
                  outlined
                  color="#333"
                  :disabled="companyName !== ''"
                  @keyup="getSelectCompany($event.target.value, 'บริษัท')"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions style="margin-top: -2%;">
          <v-row justify="center">
            <v-col cols="4">
              <v-btn class="ml-5" color="error" dark outlined @click="deletePosition">ลบตำแหน่งงาน</v-btn>
            </v-col>
            <v-col cols="3">
              <v-btn class="button-color-outline mx-5" dark outlined @click="dialogEditPosition = false">ยกเลิก</v-btn>
            </v-col>
            <v-col cols="4">
              <v-btn class="button-color mr-5" dark @click="submitData()">ยืนยันการแก้ไข</v-btn>
            </v-col>
          </v-row>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
import
{
  // getSelectCompanyEmployee, // ปิดทดสอบ29/03/66
  getSelectPositionNew,
  editPosition // บันทึกแก้ไข
  // getSelectPositionAll // ปิด 29/03/66
} from '@/API/API'
import { EventBus } from '@/EventBus'
// import TableManageCompany from './_tableManageCompany'
import swal from 'sweetalert'
export default {
  components: {
    // TableManageCompany
    // DialogAddAprover
  },
  data () {
    return {
      dialogEditPosition: false,
      chkDisable: false,
      chkDisableApprove: false,
      chkLeaderApprove: false,
      leaderApprove: 'ไม่ต้องการ',
      expand: false,
      titleType: '',
      textTitle: '',
      preName: '',
      itemCompanyName: [],
      selectDataPosition: [],
      selectData: [],
      selectDataLevel: [],
      selectDataPositionLev: [],
      keywordCompanyName: '',
      keywordPositionName: '',
      keywordPositionNameOld: '',
      employeeId: '',
      propsEmpId: '',
      position: '',
      positionId: '',
      positionLevel: '',
      companyName: '',
      company: '',
      positionData: [{
        positionName: '',
        companyName: ''
      }],
      tokenUser: this.$store.state.token,
      approver: [],
      alertText: {
        'user is already': 'มีการร้องขอรายการนี้ ในระบบแล้ว',
        'employeeId is already': 'รหัสพนักงานซ้ำ',
        'chart not found': 'ไม่พบฝ่ายงานที่ต้องการ',
        'user not found': 'ไม่พบผู้ใช้งาน',
        'position is duplicate': 'มีข้อมูลนี้ ในระบบแล้ว'
      }
    }
  },
  beforeDestroy () {
    EventBus.$off('opendialogEditPosition')
  },
  mounted () {
    EventBus.$on('opendialogEditPosition', this.openDialogEditPosition)
  },
  created () {
    // this.initSelectData()
    // this.getListPosition()
    this.getSelectCompany()
  },
  watch: {
  },
  methods: {
    openDialogEditPosition (item) {
      this.dialogEditPosition = true
      this.position = item.positionName
      this.companyName = item.companyId
      this.company = item.companyName
      this.positionId = item._id
      this.positionLevel = item.positionLevelId
      this.getSelectCompany()
    },
    deletePosition () {
      EventBus.$emit('closedialogEditPosition', this.positionId, 'delete')
      this.dialogEditPosition = false
    },
    // async getListPosition () {
    //   this.loading = true
    //   this.selectDataPosition = []
    //   const token = this.tokenUser

    //   try {
    //     const res = await getSelectPositionAll(token)
    //     if (res.success) {
    //       if (res.result.length) {
    //         for (let index = 0; index < res.result[0].position.length; index++) {
    //           this.selectDataPosition.push(res.result[0].position[index].positionName)
    //         }
    //         // this.selectDataPosition = res.result[0].position
    //         this.selectDataLevel = res.result[1].positionLvName
    //       }
    //       console.log('Select Positionn Level', this.selectDataLevel)
    //     } else {
    //       // console.log(res)
    //     }
    //   } catch (error) {
    //     // alert(error)
    //     console.log(error)
    //   } finally {
    //     this.loading = false
    //   }
    // },

    // async initSelectData (value) {
    //   this.loading = true
    //   const token = this.tokenUser
    //   var obj = {
    //     positionName: '',
    //     companyName: value,
    //     companyId: '',
    //     positionLevelName: '',
    //     positionLevel: ''
    //   }
    //   try {
    //     // const res = await getSelectCompanyEmployee(token) // ปิดทดสอบ 29/03/66
    //     const res = await getSelectPositionNew(obj, token)
    //     if (res.success) {
    //       this.selectData = res.company
    //       // console.log('Select Positionn', this.selectData)
    //     } else {
    //       // console.log(res)
    //     }
    //   } catch (error) {
    //     // alert(error)
    //     console.log(error)
    //   } finally {
    //     // this.loading = false
    //   }
    // },
    async getSelectCompany (value, key) {
      this.loading = true
      var datafilterall = ''
      const token = this.tokenUser
      if (key === 'ตำแหน่งงาน') {
        const obj = {
          positionName: value,
          companyName: '',
          companyId: '',
          positionLevelName: '',
          positionLevel: ''
        }
        datafilterall = obj
      } else if (key === 'ระดับตำแหน่ง') {
        const obj = {
          positionName: '',
          companyName: '',
          companyId: '',
          positionLevelName: value,
          positionLevel: ''
        }
        datafilterall = obj
      } else if (key === 'บริษัท') {
        const obj = {
          positionName: '',
          companyName: value,
          companyId: '',
          positionLevelName: '',
          positionLevel: ''
        }
        datafilterall = obj
      } else {
        var newcompany = ''
        var companyNEW = ''
        if (this.company !== null) {
          if (this.company.includes('-')) {
            newcompany = this.company.split(' - ').pop()
            if (newcompany.includes('(')) {
              companyNEW = newcompany.split(' (', 1)[0]
            } else {
              companyNEW = newcompany
            }
          } else {
            companyNEW = this.company
          }
        } else {
          companyNEW = ''
        }
        const obj = {
          positionName: this.position,
          companyName: companyNEW,
          companyId: '',
          positionLevelName: '',
          positionLevel: ''
        }
        datafilterall = obj
      }
      try {
        const res = await getSelectPositionNew(datafilterall, token)
        if (res.success) {
          if (key === 'ตำแหน่งงาน') {
            this.selectDataPosition = res.position // ตำแหน่งงาน
          } else if (key === 'ระดับตำแหน่ง') {
            this.selectDataLevel = res.positionLevelResult // ระดับตำแหน่ง
          } else if (key === 'บริษัท') {
            this.selectData = res.company // บริษัท
          } else {
            this.selectData = res.company // บริษัท
            this.selectDataPosition = res.position // ตำแหน่งงาน
            this.selectDataLevel = res.positionLevelResult // ระดับตำแหน่ง
          }
        }
      } catch (error) {
        // alert(error)
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async submitData () {
      this.propsitems = this.$route.params.item
      const obj = {
        positionId: this.positionId,
        positionName: typeof this.position === 'object' ? this.position.positionName : this.position,
        companyId: this.companyName,
        positionLevelId: this.positionLevel
      }
      if (this.positionLevel === undefined || this.position === undefined) {
        swal('คำเตือน', 'กรุณากรอกข้อมูลให้ครบ', 'warning', {
          button: false,
          timer: 2000
        })
      } else {
        try {
          const res = await editPosition(obj, this.tokenUser)
          if (!res) {
            swal('ผิดพลาด', 'มีข้อมูลนี้ ในระบบแล้ว', 'error', {
              button: false,
              timer: 2000
            })
          } else {
            EventBus.$emit('closedialogEditPosition', this.positionId, 'edit')
            this.dialogEditPosition = false
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      }
    }
  }
}
</script>
<style scoped>
@import '../../../css/ManageEmployee.css';
</style>
